import { render, staticRenderFns } from "./PromotionLabels.vue?vue&type=template&id=1527d428"
import script from "./PromotionLabels.vue?vue&type=script&lang=js"
export * from "./PromotionLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports